import { useState as t, useEffect as r, useLayoutEffect as e } from "react";

function n(t, r) {
  var e = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }

  return e;
}

function o(t) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? n(Object(e), !0).forEach(function (r) {
      u(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : n(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }

  return t;
}

function i(t) {
  return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, i(t);
}

function u(t, r, e) {
  return r in t ? Object.defineProperty(t, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = e, t;
}

function a() {
  return a = Object.assign ? Object.assign.bind() : function (t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }

    return t;
  }, a.apply(this, arguments);
}

function c(t, r) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, r) {
    var e = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == e) return;
    var n,
        o,
        i = [],
        u = !0,
        a = !1;

    try {
      for (e = e.call(t); !(u = (n = e.next()).done) && (i.push(n.value), !r || i.length !== r); u = !0);
    } catch (t) {
      a = !0, o = t;
    } finally {
      try {
        u || null == e.return || e.return();
      } finally {
        if (a) throw o;
      }
    }

    return i;
  }(t, r) || l(t, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function f(t) {
  return function (t) {
    if (Array.isArray(t)) return s(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || l(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function l(t, r) {
  if (t) {
    if ("string" == typeof t) return s(t, r);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? s(t, r) : void 0;
  }
}

function s(t, r) {
  (null == r || r > t.length) && (r = t.length);

  for (var e = 0, n = new Array(r); e < r; e++) n[e] = t[e];

  return n;
}

function y(e, n) {
  var o = c(t(function () {
    var t = window.localStorage.getItem(e);
    if (null !== t) try {
      return JSON.parse(t);
    } catch (r) {
      console.error("localStorage error:", e, t, r);
    }
    return window.localStorage.setItem(e, JSON.stringify(n)), n;
  }), 2),
      i = o[0],
      u = o[1];
  return r(function () {
    window.localStorage.setItem(e, JSON.stringify(i));
  }, [e, i]), [i, u];
}

function b(t, e) {
  r(function () {
    function r(r) {
      r.key === t && e(r);
    }

    return document.addEventListener("keydown", r), function () {
      document.removeEventListener("keydown", r);
    };
  }, [t, e]);
}

function p(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
  r(function () {
    function r(r) {
      var n = r.target;
      e.some(function (t) {
        return null == t ? void 0 : t.contains(n);
      }) || t();
    }

    return document.addEventListener("mousedown", r), function () {
      document.removeEventListener("mousedown", r);
    };
  }, [e, t]);
}

function m(r) {
  var n = c(t(), 2),
      o = n[0],
      i = n[1];
  return e(function () {
    var t,
        e = r.current,
        n = function () {
      setTimeout(function () {
        return i(e.scrollWidth > e.offsetWidth);
      }, 0);
    };

    return e && ("ResizeObserver" in window ? (t = new ResizeObserver(n)).observe(e) : n()), function () {
      return t.disconnect();
    };
  }, [r]), o;
}

export { i as _, c as a, a as b, m as c, p as d, f as e, y as f, o as g, u as h, b as u };